export default "__VITE_ASSET__Vug6j8g7__"